import Vuex from 'vuex'
import { verifycode, getUserProduct, creatTrade, getTradeById, creatPayTrade, queryOfficialUrl, creaTmallChpaTrade, getQRcodeBlob, getLogoUrl } from '../api'
import { findDataByid } from '../api/wfcheckpay'
import Vue from 'vue'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    activeKey: '',
    activeObj: {},
    userProduct: {},
    qrUrl: null,
    choosedPrd:{},
    fileCount:0,
    inputCount:0,
    title:null,
    fieldsValue:{},
    inputText:'',
    fileList:[],
    tabKey:'1',
    logoUrl:null,
  },
  mutations: {
    changeKey (state, key = {}) {
      state.activeKey = key.userProductCode || ''
      state.activeObj = key || {}
      state.fieldsValue = {}
      state.fileList = []
    },
    changeProduct (state, key) {
      state.userProduct = key
    },
    saveQRUrl (state, key) {
      state.qrUrl = key
    },
    saveChoosedPrd (state, payload) {
      state.choosedPrd = payload.product
    },
    saveTitle (state, payload) {
      state.title = payload.title
    },
    saveFieldsValue (state, payload) {
      state.fieldsValue = payload.fieldsValue
    },
    saveFileCount (state, payload) {
      state.fileCount = payload.fileCount
    },
    saveInputCount (state, payload) {
      state.inputCount = payload.inputCount
      state.inputText = payload.inputText
    },
    saveFileList (state, payload) {
      state.fileList = payload.fileList
    },
    saveTabKey (state, payload) {
      state.tabKey = payload.tabKey
    },
    saveLogoUrl (state, key) {
      state.logoUrl = key
    },
  },

  actions: {
    // 创建订单
    creatTrade (state,{payload, callback}) {
      creatTrade(payload).then(res => {
        callback(res)
      })
    },
    // 创建支付订单
    creatPayTrade(_, {payload, callback }) {
      if(payload.payType === 'TMALL') {
        creaTmallChpaTrade(payload).then(res => {
          callback(res)
        })
      } else {
        creatPayTrade(payload).then(res => {
          callback(res)
        })
      }
    },
    // 创建支付订单公众号(公众号)，获取公众号二维码
    getOfficialUrl(_, {payload, callback }) {
      queryOfficialUrl(payload.tradeId).then(res => {
        callback(res)
      })
    },

    // 是否支付
    requests({ state }, {payload, callback }) {
      const userProduct = state.userProduct
      verifycode(payload).then(res => {
        callback(res)
        if(res.success && res.data.payState && res.data.payState === 'PAID') {
          this.commit('check/changeKey', userProduct.userProducts[0])
          this.commit('check/changeTradeCodeData', {})
        }
      })
    },
    // 获取产品信息
    getUserProduct(state, { payload }) {
      getUserProduct().then(res => {
        if(res && res.error_code && res.error_code === '10000') {
          // res.result.userProducts.map((item)=>{
          //   switch(item.userProductCode){
          //     case 'kczy':
          //       item.pic = product_kczy
          //       item.smallPic = prd_kczy
          //       break
          //     case 'ttcheck':
          //       item.pic = product_ttcheck
          //       item.smallPic = prd_ttcheck
          //       break
          //     case 'wfbd':
          //       item.pic = product_wfbd
          //       item.smallPic = prd_wfbd
          //       break
          //     case 'wfmd':
          //       item.pic = product_wfmd
          //       item.smallPic = prd_wfmd
          //       break
          //     case 'wfty':
          //       item.pic = product_wfty
          //       item.smallPic = prd_wfty
          //       break
          //     case 'xsys':
          //       item.pic = product_xsys
          //       item.smallPic = prd_xsys
          //   }
          // })
          let index = res.result.userProducts.findIndex(item => item.userProductCode === payload.product)
          if(index < 0) {
            index = 0
          }
          this.commit('check/changeKey', res.result.userProducts[index])
          this.commit('check/changeProduct', res.result)
        }
      })
    },
    // 获取二维码图片Blob
    getQRcodeUrl() {
      getQRcodeBlob().then(res => {
        if(res && res.size > 0) {
          this.commit('check/saveQRUrl', window.URL.createObjectURL(res))
        }
      })
    },
    // 根据订单查详情，支付前
    getTradeById(state, { payload, callback }) {
      getTradeById(payload).then(res => {
        callback(res)
      })
    },
    // 根据查询码查结果，支付后
    findDataByid(state, { payload, callback }) {
      findDataByid(payload).then(res => {
        callback(res)
      })
    },

    // 获取logo
    getLogo() {
      getLogoUrl().then(res=>{
        if(res && res.size > 0) {
          this.commit('check/saveLogoUrl', window.URL.createObjectURL(res))
        }
      }) 
    },
  }
}
